module.exports = __webpack_public_path__ + "img/2_260.b0ab60a8.png";